import 'react';
import 'prop-types';
import { SideBarToModal, Button } from 'reaxl';
import { useDevice } from '@atc/react-device';
import TaxesFeesBreakdownForm from '../TaxesFeesBreakdownForm/TaxesFeesBreakdownForm.js';
import { jsx } from 'react/jsx-runtime';
function TaxesFeesModal(_ref) {
  let {
    container,
    // For Syndicated Calc
    zip,
    onHide = () => {},
    showModal = false,
    setHasUpdatedZip = () => {},
    renderTaxesFeesBreakdown = () => {},
    taxesFeesSectionProps = {},
    handleChange = () => {},
    handleSubmit = () => {}
  } = _ref;
  const device = useDevice();
  const isXs = device?.is?.xs ?? false;
  const {
    isLoading = false,
    hasError = false
  } = taxesFeesSectionProps || {};
  const handleModalHide = () => {
    onHide();
    setHasUpdatedZip(false);
  };
  const continueButton = /*#__PURE__*/jsx(Button, {
    type: "button",
    bsStyle: "primary",
    onClick: handleSubmit,
    disabled: hasError || isLoading,
    children: "Apply Taxes & Fees"
  });
  return /*#__PURE__*/jsx(SideBarToModal, {
    "data-cmp": "taxes-fees-modal",
    title: "Taxes & Fees",
    show: showModal,
    container: container,
    content: /*#__PURE__*/jsx(TaxesFeesBreakdownForm, {
      zip: zip,
      titleLabel: "Confirm Your Location",
      ctaLabel: "Update Taxes & Fees",
      onSubmit: handleChange,
      renderTaxesFeesBreakdown: renderTaxesFeesBreakdown,
      taxesFeesSectionProps: taxesFeesSectionProps
    }),
    collapsed: isXs,
    modalOptions: {
      bsStyle: 'sm'
    },
    sideBarOptions: {
      fullWidth: true,
      action: continueButton
    },
    footerContent: continueButton,
    onHide: handleModalHide
  });
}
export { TaxesFeesModal as default };
